import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState } from 'react';
import Select from 'react-select'
import { API_URL } from '..';

const AddStockLayer = () => {
 const [formValues, setFormValues] = useState({
    title:'',
    sellPrice:0,
    costPrice:0,
    quantity:0,

 });
 const handleSubmit = async(e) =>{
      e.preventDefault();
        const user = JSON.parse(localStorage.getItem('user'));
      
          let headersList = {
            "Accept": "*/*",
            "Content-Type": "application/json"
           }
          let response = await fetch( API_URL+`/api/invoice/stock/create`, { 
            method: "POST",
            headers: headersList,
            body:JSON.stringify(formValues)
          });
          const data = await response.json();
          console.log(data)
          setFormValues({
            title:'',
            sellPrice:0,
            costPrice:0,
            quantity:0,
          })    
 }
  
    return (
        <div className="card h-100 p-0 radius-12">
            <div className="card-body p-24">
                <div className="row justify-content-center">
                    <div className="col-xxl-6 col-xl-8 col-lg-10">
                        <div className="card border">
                            <div className="card-body">
                                
                                {/* Upload Image End */}
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-20">
                                        <label
                                            htmlFor="name"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                           Title <span className="text-danger-600">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control radius-8"
                                            id="title"
                                            value={formValues.title}
                                            onChange={(e)=>setFormValues((prev)=>({...prev,title: e.target.value}))}
                                            placeholder="Title...."
                                        />
                                    </div>
                                    <div className="mb-20">
                                        <label
                                            htmlFor="buy"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                        Buy Price <span className="text-danger-600">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control radius-8"
                                            id="buy"
                                            value={formValues.costPrice}
                                            onChange={(e)=>setFormValues((prev)=>({...prev,costPrice: e.target.value}))}
                                            placeholder="0.00"
                                        />
                                    </div>
                                    <div className="mb-20">
                                        <label
                                            htmlFor="sell"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                        Selling Price <span className="text-danger-600">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control radius-8"
                                            id="sell"
                                            value={formValues.sellPrice}
                                            onChange={(e)=>setFormValues((prev)=>({...prev,sellPrice: e.target.value}))}
                                            placeholder="0.00"
                                        />
                                    </div>
                                    
                                    <div className="mb-20">
                                        <label
                                            htmlFor="qty"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                           Quantity
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control radius-8"
                                            id="qty"
                                            value={formValues.quantity}
                                            onChange={(e)=>setFormValues((prev)=>({...prev,quantity: e.target.value}))}
                                            min={1}
                                            placeholder="Enter Quantity"
                                        />
                                    </div>
                                    
                                
                                  
                                    <div className="d-flex align-items-center justify-content-center gap-3">
                                      
                                        <button
                                            type="submit"
                                            className="btn btn-primary border border-primary-400 text-md px-56 py-12 radius-8"
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default AddStockLayer;